import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { PlannedCourse } from '../../../global/builders/planned_course_builder';
import { APPlannedCourseServant } from '../../../global/servants/ap_planned_course_servant';
import { DEEMPHASIZE_DROP_AREA, EMPHASIZE_DROP_AREA } from '../../../plan/constants/event_names';
import { APDegreeMapQuery } from '../../components/degree_map/queries/ap_degree_map_query';
import { APAdvisorText } from './../../../global/servants/ap_advisor_text_servant';

export class APDegreeMap {
  private advisorText: string = 'advisor';
  private isEditable: boolean | string;

  constructor(
    private ngAPDegreeMapQuery: APDegreeMapQuery,
    private ngAPAdvisorText: APAdvisorText,
    private ngComponentCommunicatorService: CommunicatorService,
    private phxFeatureConfiguration: any
  ) {}

  emphasizeDropArea() {
    this.ngComponentCommunicatorService.publish(EMPHASIZE_DROP_AREA);
  }
  deEmphasizeDropArea() {
    this.ngComponentCommunicatorService.publish(DEEMPHASIZE_DROP_AREA);
  }

  nonGroupedSlotGroup() {
    return this.ngAPDegreeMapQuery.result.nonDevReqCourses;
  }
  showProgramSlotAsAccordion() {
    // if we have at least one unique NK in group data
    return !_4.isEmpty(_4.compact(_4.uniq(_4.map(this.ngAPDegreeMapQuery.result.yearGroups, 'nk'))));
  }

  hasDevReqs() {
    return !_4.isEmpty(this.ngAPDegreeMapQuery.result.devReqCourses);
  }

  getStatusBadgeForPlannedCourse(plannedCourse: PlannedCourse) {
    return APPlannedCourseServant.statusBadge(plannedCourse);
  }

  $onChanges() {
    this.advisorText = this.ngAPAdvisorText.advisorLabel;
    this.isEditable = _4.isBoolean(this.isEditable) ? this.isEditable : this.isEditable === 'true';
  }
}

class APDegreeMapComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      slots: '=',
      isEditable: '<?'
    };
    this.controller = APDegreeMap;
    this.templateUrl = 'capability-ng-academic-planner/src/plan/components/degree_map/degree_map.html';
  }
}
angular.module('capability-ng-academic-planner').component('apDegreeMap', new APDegreeMapComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/degree_map/degree_map.ts